import AnimationFactory from "../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import FadeToColorOptions from "../../../../lib/html5-software-library/src/ranj/ui/animation/transition-animations/FadeToColorOptions";

export default class ScreenTransition {
    static get fadeColorIn() {
        return {
            animationType: AnimationFactory.FADE_TO_COLOR_IN,
            animationOptions: new FadeToColorOptions('#000', .5, 0, 650, createjs.Ease.sineInOut),
        };
    }

    static get fadeColorOut() {
        return {
            animationType: AnimationFactory.FADE_TO_COLOR_OUT,
            animationOptions: new FadeToColorOptions('#000', .5, 0, 650, createjs.Ease.sineInOut),
        };
    }

    static get fadeIn() {
        return {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 650, createjs.Ease.sineInOut),
        };
    }

    static get fadeOut() {
        return {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 650, createjs.Ease.sineInOut),
        };
    }
}